import * as React from 'react'; // https://github.com/parcel-bundler/parcel/issues/1199

const LoadingSpinnerComponent = () => (
    <div className="sid-spinner">
        <div className="sid-spinner__frame" />
        <div className="sid-spinner__frame" />
        <div className="sid-spinner__frame" />
        <div className="sid-spinner__frame" />
    </div>
);

export { LoadingSpinnerComponent };
